import cloneDeep from 'lodash/cloneDeep'
import { Component, Prop, Vue, Ref, Watch } from 'vue-property-decorator'

@Component
export default class EditDialogMixin<T> extends Vue {

  /**
   * You need to add a validation observer to your dialog and add the attribute
   * `ref="valdiator"`.
   */
  @Ref()
  protected validator!: ValidationObserver

  protected dialog = false
  protected editMode = false
  protected model!: T

  public cancel() {
    this.$emit('cancel')
    this.dialog = false
  }

  public close() {
    this.dialog = false
  }

  public openNew(model: T) {
    this.openInternal(false, model)
  }

  public openEdit(model: T) {
    this.openInternal(true, model)
  }

  protected async confirm() {
    if (await this.validator.validate()) {
      this.$emit(this.editMode ? 'update' : 'create', this.model)
    }
  }

  protected async validate() {
    if (this.validator) {
      await this.validator.validate()
    }
  }

  private async openInternal(editMode: boolean, model: T) {
    this.editMode = editMode
    this.model = cloneDeep(model)
    this.dialog = true
    // setTimeout(async () => await this.validate(), 100)
    // await this.validate()
    // this.reset()
  }

  private reset() {
    // For some odd reason, the validator is not ready upon first invocation
    // of the dialog.
    if (this.validator) {
      this.validator.reset()
    }
  }
}
